import * as getters from './getters';

import actions from './actions';
import mutations from './mutations';
import { ComponentIds } from '~/utils/componentIds';

const state = () => ({
  // TODO rename this from tutorial to onboarding to reduce confusion
  hasCompletedTutorial: false,
  // TODO: check whether tutorialStep is still needed and remove it if not (see usages in mutations.js, getters.js, authentication/actions.js, OnboardingWrapper.vue, NewsUpdateModalWrapper.vue)
  tutorialStep: 0,
  tutorialLoading: false,
  recommendedCompanies: null,
  recommendedCompaniesLoading: false,
  recommendedCompaniesSearchQuery: '',
  nextCompaniesLoading: false,
  companiesOffset: 1,
  showMoreCompanies: true,
  recommendedProfiles: null,
  recommendedProfilesLoading: false,
  recommendedProfilesSearchQuery: '',
  nextProfilesLoading: false,
  profilesOffset: 1,
  showMoreProfiles: true,
  birthdateSuccess: false,
  birthdateErrors: null,
  userOnboardingQuestions: [],
  userOnboardingAnswers: [],
  onboardingTooltips: {
    steps: [
      {
        id: 0,
        target: ComponentIds.CreatePortfolioButtonId,
        text: 'onboarding_tooltip_step_1',
        buttonText: 'next',
        placement: 'bottom',
      },
      {
        id: 1,
        target: ComponentIds.TopPortfoliosId,
        text: 'onboarding_tooltip_step_2',
        buttonText: 'next',
        placement: 'bottom',
      },
      {
        id: 2,
        target: ComponentIds.BottomMobileNavbarId,
        text: 'onboarding_tooltip_step_3',
        buttonText: 'next',
        placement: 'top',
      },
      {
        id: 3,
        target: ComponentIds.HelpIconId,
        text: 'onboarding_tooltip_step_4',
        buttonText: 'finish',
        placement: 'bottom',
      },
    ],
    activeStepIndex: 0,
    isVisible: false,
  },
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
